import { render, staticRenderFns } from "./ArquivoAFD.vue?vue&type=template&id=0aa9f20e&"
import script from "./ArquivoAFD.vue?vue&type=script&lang=js&"
export * from "./ArquivoAFD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports